export default __webpack_public_path__ + "static/media/twt-logo.8097ca9d.svg";